const t = {
  name: "ProductDesignTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5ZM4 5V13H15V4H5C4.44772 4 4 4.44772 4 5ZM4 15V19C4 19.5523 4.44772 20 5 20H15V15H4ZM17 20H19C19.5523 20 20 19.5523 20 19V8H17V20ZM17 6H20V5C20 4.44772 19.5523 4 19 4H17V6Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ProductDesignTeam
};
